import React from 'react'
import styled from 'styled-components'

const Introduction = styled.section`
  h4.statement {
    font-size: 2.8em;
    line-height: .98;
    text-transform: uppercase;
    letter-spacing: -0.05em;
  }
  i {
    text-decoration: none;
    font-style: normal;
    break-inside: avoid;
    white-space: nowrap;
  }
`

export default () => <Introduction>
  <h4 className="statement">Full<br/>Service<br/>film<br/>production</h4>
  <p>Founded by Director/DOP <i>Anton Zabriskie</i>, <i>Very Film</i> produces branded content, commercials and shorts. From scripting to storyboarding, from scouting to casting, from shooting to mastering: we offer full production services 24/7.</p>
</Introduction>



// WEBPACK FOOTER //
// ./src/components/Introduction.js